import { render, staticRenderFns } from "./ModalCreatePrizeDraw.vue?vue&type=template&id=571fca78"
import script from "./ModalCreatePrizeDraw.vue?vue&type=script&lang=js"
export * from "./ModalCreatePrizeDraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports